
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("g0cTP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $ba66a6f7d5ce89bd$var$_jquery = $ba66a6f7d5ce89bd$var$_interopRequireDefault((parcelRequire("4kMWr")));
function $ba66a6f7d5ce89bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $ba66a6f7d5ce89bd$var$init = module.exports.init = function init() {
    var attempts = 0;
    // Karten-Variablen
    var $map = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])("#project-map");
    var bigSize = new Array();
    var smallSize = new Array();
    var bLeft;
    var bTop;
    var rel;
    var fak;
    var big = false;
    /**
   * Dient als Comparator für die Methode Array.sort und
   * definiert, wie Characters verglichen werden sollen.
   * Ignoriert Groß- Kleinschreibung und sortiert Umlaute
   * zu den entsprtechenden Selbstlauten.
   * (ä == a, ß == s, usw.)
   * @param a erstes Argument
   * @param b zweites Argument
   * @return  0, wenn beide Argumente gleich sind
   *    -1, wenn a größer als b ist
   *     1, sonst
   */ function stringComparison(a, b) {
        a = a.toLowerCase();
        a = a.replace(/ä/g, "a");
        a = a.replace(/ö/g, "o");
        a = a.replace(/ü/g, "u");
        a = a.replace(/ß/g, "s");
        b = b.toLowerCase();
        b = b.replace(/ä/g, "a");
        b = b.replace(/ö/g, "o");
        b = b.replace(/ü/g, "u");
        b = b.replace(/ß/g, "s");
        return a == b ? 0 : a > b ? 1 : -1;
    }
    // Language
    var lang = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])("html").attr("lang");
    if (!lang) lang = "de";
    var langLabels = Array();
    langLabels["de"] = Array();
    langLabels["en"] = Array();
    langLabels["fr"] = Array();
    langLabels["es"] = Array();
    // Viewport-Dimensionen feststellen
    var vW = new Array();
    var vH = new Array();
    vW.push(window.innerWidth);
    vH.push(window.innerHeight);
    /**
   * Wenn sich der Viewport ändert, wird diese Funktion aufgerufen um nötige Anpassungen vorzunehmen
   *  - Größe des HTML5-Video-Containers
   *  - Update der Karten-Variablen, Platzierung der Fähnchen auf der Projekt-Karte
   *  - Galerie: Bei Bedarf Höhe an Bildelemente innerhalb anpassen
   */ function viewport() {
        vW.push(window.innerWidth);
        vH.push(window.innerHeight);
        // Update der Karten-Variablen
        /*smallSize['width'] = $('.welt').width();
    smallSize['height'] = $('.welt').height();*/ smallSize["height"] = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt").height();
        smallSize["width"] = smallSize["height"] * bigSize["width"] / bigSize["height"];
        //bLeft = smallSize['width'] - bigSize['width'];
        bLeft = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(window).innerWidth() - bigSize["width"];
        bTop = smallSize["height"] - bigSize["height"];
        rel = bigSize["width"] / smallSize["width"];
        // Karte auf Anfangszustand setzen (nicht gezoomt)
        big = false;
        (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_zoom a").removeClass("minus");
        (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild").css({
            width: smallSize["width"],
            height: smallSize["height"],
            /*left: 0,
      top: 0*/ left: ($map.width() - smallSize["width"]) / 2,
            top: 0
        });
        // Fähnchen neu platzieren
        fak = 940 / smallSize["width"];
        (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".fahne").each(function(index) {
            var newLeft = parseInt((0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).attr("data-left")) / fak;
            var newTop = parseInt((0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).attr("data-top")) / fak;
            (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).css({
                left: newLeft,
                top: newTop
            });
        });
        /*
     * Positionen der Info-Ebenen anpassen: rechts von der Mitte sollen sich die
     * Info-Ebenen nach links einblenden
     */ var centerX = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt").width() / 2;
        var centerY = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt").height() / 2;
        (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".fahne").each(function(index) {
            (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).removeClass("rechts");
            var pos = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).position();
            if (pos.left > centerX) (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).addClass("rechts");
        });
    }
    // Karte: Konstruktion und Funktionalitäten
    (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(function() {
        // Karte der Projekte
        langLabels["de"]["karte_projekte"] = Array();
        langLabels["de"]["karte_projekte"]["all_countries"] = "Alle L\xe4nder";
        langLabels["de"]["karte_projekte"]["projects_by_country"] = "Projekte nach L\xe4ndern";
        langLabels["de"]["karte_projekte"]["all_topics"] = "Alle Themen";
        langLabels["de"]["karte_projekte"]["projects_by_topic"] = "Projekte nach Themen";
        langLabels["en"]["karte_projekte"] = Array();
        langLabels["en"]["karte_projekte"]["all_countries"] = "All Countries";
        langLabels["en"]["karte_projekte"]["projects_by_country"] = "Projects by Country";
        langLabels["en"]["karte_projekte"]["all_topics"] = "All topics";
        langLabels["en"]["karte_projekte"]["projects_by_topic"] = "Projects by topic";
        // Koordinaten anzeigen?
        if ((0, $ba66a6f7d5ce89bd$var$_jquery["default"])("#welt_coords") != undefined && (0, $ba66a6f7d5ce89bd$var$_jquery["default"])("#welt_coords").length > 0) (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(function() {
            var map = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])("img.welt_img");
            var offset = map.offset();
            (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(document).mousemove(function(e) {
                var left = parseInt(e.pageX - offset.left);
                var top = parseInt(e.pageY - offset.top);
                var outer = false;
                if (left < 0) {
                    left = 0;
                    outer = true;
                }
                if (top < 0) {
                    top = 0;
                    outer = true;
                }
                if (left > (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(map).width()) {
                    left = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(map).width();
                    outer = true;
                }
                if (top > (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(map).height()) {
                    top = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(map).height();
                    outer = true;
                }
                if (!outer) (0, $ba66a6f7d5ce89bd$var$_jquery["default"])("#welt_coords").html("Oben: " + top + ", Links:" + left);
            });
        });
        function karte_show(val) {
            // Alle Fähnchen einblenden
            if (val == "#") (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".fahne").show();
            else {
                // Alle Fähnchen ausblenden
                (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".fahne").hide();
                // Gewünschte einblenden
                (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".fahne").filter(function(index) {
                    var land = "";
                    var thema = "";
                    // Einstellungen für Fahne suchen
                    (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).find("span").each(function() {
                        if ((0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).hasClass("fahne_thema")) thema = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).html();
                        if ((0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).hasClass("fahne_land")) land = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).html();
                    });
                    return land == val || thema == val;
                }).show();
            }
        }
        // Dropdowns erstellen anhand der in der Karte vorgefundenen Projekte
        // Wenn mindestens ein Fähnchen vorhanden ist, werden die Dropdowns erstellt
        // Da jedes Projekt einem Land sowie einem Thema zugeordnet ist,
        // muss nicht geprüft werden, ob Länder oder Themen vorhanden sind
        if ((0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt .fahne") != undefined && (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt .fahne").length > 0) {
            var laender = new Array();
            var themen = new Array();
            (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".fahne").each(function(index) {
                var land = "";
                var thema = "";
                // Einstellungen für Fahne suchen
                (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).find("span").each(function() {
                    if ((0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).hasClass("fahne_thema")) thema = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).html();
                    if ((0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).hasClass("fahne_land")) land = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).html();
                });
                // Länder in Array schreiben
                var test = laender.join(" ");
                if (test.indexOf(land) === -1) laender.push(land);
                // Themen in Array schreiben
                var test_2 = themen.join(" ");
                if (test_2.indexOf(thema) === -1) themen.push(thema);
            });
            // Arrays alphabetisch sortieren
            laender.sort(stringComparison);
            themen.sort(stringComparison);
            // Code bauen
            var code_dd = "";
            code_dd += '<div class="welt_dropdowns">\n';
            code_dd += ' <select class="welt_dd" name="select_laender" id="select_laender">\n';
            // code_dd += '  <option value="" selected disabled>' + langLabels[lang]["karte_projekte"]["projects_by_country"] + "</option>\n";
            code_dd += '  <option value="#" selected>' + langLabels[lang]["karte_projekte"]["all_countries"] + "</option>\n";
            for(var i = 0; i < laender.length; i++)code_dd += '  <option value="' + laender[i] + '">' + laender[i] + "</option>\n";
            code_dd += " </select>\n";
            code_dd += ' <select class="welt_dd" name="select_themen" id="select_themen">\n';
            // code_dd += '  <option value="" selected disabled>' + langLabels[lang]["karte_projekte"]["projects_by_topic"] + "</option>\n";
            code_dd += '  <option value="#" selected>' + langLabels[lang]["karte_projekte"]["all_topics"] + "</option>\n";
            for(var _i = 0; _i < themen.length; _i++)code_dd += '  <option value="' + themen[_i] + '">' + themen[_i] + "</option>\n";
            code_dd += " </select>\n";
            code_dd += "</div>\n";
            // Code einfügen
            (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt").after(code_dd);
            // Display flags as selected and reset the other select
            (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_dropdowns").on("change", function(e) {
                if (e.target.id === "select_themen") (0, $ba66a6f7d5ce89bd$var$_jquery["default"])("#select_laender").prop("selectedIndex", 0);
                else (0, $ba66a6f7d5ce89bd$var$_jquery["default"])("#select_themen").prop("selectedIndex", 0);
                karte_show(e.target.value);
            });
        }
        if ((0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt") != undefined && (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt").length > 0) {
            // console.log($('.welt_bild img.welt_img').width());
            //bigSize['width']	= $('.welt_bild img.welt_img').width();
            //bigSize['height']	= $('.welt_bild img.welt_img').height();
            bigSize["width"] = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild img.welt_img").attr("width");
            bigSize["height"] = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild img.welt_img").attr("height");
            /*smallSize['width']	= $('.welt').width();
      smallSize['height']	= $('.welt').height();*/ smallSize["height"] = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt").height();
            smallSize["width"] = smallSize["height"] * bigSize["width"] / bigSize["height"];
            rel = bigSize["width"] / smallSize["width"];
            fak = 940 / smallSize["width"];
            // Bild auf kleine Größe setzen bzw. auf 100%, damit sichs dem Container außenrum anpasst
            (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild img.welt_img").width("100%").height("100%");
            setTimeout(function() {
                return (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild").fadeIn();
            }, 200);
            // console.log("Karte anzeigen");
            // Fähnchen neu positionieren
            /*
       * $('.fahne').each(function(index) {
       *	$(this).css('left',$(this).attr('left') / rel);
       *	$(this).css('top',$(this).attr('top') / rel);
       * });
       */ // Positionen der Info-Ebenen anpassen: rechts von der Mitte sollen sich die Info-Ebenen nach links einblenden
            var centerX = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt").width() / 2;
            var centerY = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt").height() / 2;
            (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".fahne").each(function(index) {
                var pos = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).position();
                if (pos.left > centerX) (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).addClass("rechts");
            });
            // Ein- und Ausblenden der Projekt-Info
            var previousFlag;
            if (vW > 768) (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".fahne .fahne_inhalt").hover(function() {
                (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).parents(".fahne").find(".info").show();
                (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).parents(".fahne").css("z-index", "4");
            }, function() {
                (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).parents(".fahne").find(".info").hide();
                (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).parents(".fahne").css("z-index", "2");
            });
            else (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".fahne .fahne_inhalt").on("click", function(event) {
                if (previousFlag != this) {
                    event.preventDefault();
                    (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).parents(".fahne").find(".info").show();
                    (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).parents(".fahne").css("z-index", "4");
                    if (previousFlag) {
                        (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(previousFlag).parents(".fahne").find(".info").hide();
                        (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(previousFlag).parents(".fahne").css("z-index", "2");
                    }
                }
                previousFlag = this;
            });
            // Zoom: Karte vergrößern / verkleinern, Positionen der Fähnchen anpassen, Karte bewegbar / unbewegbar machen
            big = false;
            var drag = false;
            var coords = new Array(0, 0);
            //bLeft = smallSize['width'] - bigSize['width'];
            bLeft = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(window).innerWidth() - bigSize["width"];
            bLeft = smallSize["width"] - bigSize["width"];
            var bRight = 0;
            bTop = smallSize["height"] - bigSize["height"];
            var bBottom = 0;
            // ==========================================================================
            // zoom in
            // ==========================================================================
            (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_zoom.plus").on("click", function(event) {
                if (!(0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).hasClass("disabled") || !(0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).parent().hasClass("disabled")) {
                    (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_zoom.minus").removeClass("disabled");
                    // Karte vergrößern und zentrieren
                    (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild").animate({
                        width: bigSize["width"],
                        height: bigSize["height"],
                        //left: -(((bigSize['width'] - smallSize['width']) / 2) + (($(window).innerWidth() - bigSize['width']) / 2)),
                        left: ((0, $ba66a6f7d5ce89bd$var$_jquery["default"])(window).innerWidth() - bigSize["width"]) / 2,
                        top: -((bigSize["height"] - smallSize["height"]) / 2)
                    }, 1000);
                    // Fähnchen neu positionieren und wieder einblenden
                    (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".fahne").each(function(index) {
                        (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).animate({
                            left: parseInt((0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).attr("data-left")) * rel / fak,
                            top: parseInt((0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).attr("data-top")) * rel / fak
                        }, 1000);
                    });
                    big = true;
                    (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).addClass("disabled");
                }
            });
            // ==========================================================================
            // zoom out
            // ==========================================================================
            (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_zoom.minus").on("click", function(event) {
                if (!(0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).hasClass("disabled") || !(0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).parent().hasClass("disabled")) {
                    (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_zoom.plus").removeClass("disabled");
                    // Karte verkleinern und positionieren
                    (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild").animate({
                        width: smallSize["width"],
                        height: smallSize["height"],
                        //left: 0,
                        left: ((0, $ba66a6f7d5ce89bd$var$_jquery["default"])(window).innerWidth() - smallSize["width"]) / 2,
                        top: 0
                    }, 1000);
                    // Fähnchen neu positionieren und wieder einblenden
                    (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".fahne").each(function(index) {
                        (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).animate({
                            left: parseInt((0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).attr("data-left")) / fak,
                            top: parseInt((0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).attr("data-top")) / fak
                        }, 1000);
                    });
                    big = false;
                    (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).addClass("disabled");
                }
            });
            // ==========================================================================
            // mouse move
            // ==========================================================================
            (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt").mousedown(function(event) {
                drag = true;
            });
            (0, $ba66a6f7d5ce89bd$var$_jquery["default"])("body").mouseup(function(event) {
                drag = false;
                // Mauszeiger zurücksetzen
                (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt").css("cursor", "auto");
            });
            // Verhindern, dass das Bild gezogen werden kann
            (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild img.welt_img").mousedown(function(event) {
                event.preventDefault();
            });
            (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild img.welt_img").mousemove(function(event) {
                event.preventDefault();
            });
            (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt").mousemove(function(event) {
                coords.push(event.pageX, event.pageY);
                var deltaX = coords[coords.length - 2] - coords[coords.length - 4];
                var deltaY = coords[coords.length - 1] - coords[coords.length - 3];
                var needsMove = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(window).width() < (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_img").width();
                if (drag === true && needsMove === true) {
                    // Mauszeiger anpassen
                    (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(this).css("cursor", "move");
                    // Position vorausberechnen
                    var pos = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild").position();
                    var nextLeft = pos.left += deltaX;
                    var nextTop = pos.top += deltaY;
                    // Bewegung nur ausführen, falls sie nicht über die Grenzen hinausgeht
                    if (nextLeft < bLeft) (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild").css("left", bLeft);
                    else if (nextLeft > bRight) (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild").css("left", bRight);
                    else (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild").css("left", nextLeft);
                    if (nextTop < bTop) (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild").css("top", bTop);
                    else if (nextTop > bBottom) (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild").css("top", bBottom);
                    else (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild").css("top", nextTop);
                }
            });
            // ==========================================================================
            // touch move
            // ==========================================================================
            (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt")[0].ontouchstart = function(e) {
                var t = e.touches[0];
                coords.push(t.clientX, t.clientY);
                drag = true;
            };
            (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt")[0].ontouchend = function(e) {
                drag = false;
            };
            (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt")[0].ontouchmove = function(e) {
                // nur einen Finger berücksichtigen
                var needsMove = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(window).width() < (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_img").width();
                if (e.touches.length == 1 && !(0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt").is(":animated") && drag === true && needsMove === true) {
                    var t = e.touches[0];
                    coords.push(t.clientX, t.clientY);
                    var deltaX = coords[coords.length - 2] - coords[coords.length - 4];
                    var deltaY = coords[coords.length - 1] - coords[coords.length - 3];
                    // Position vorausberechnen
                    var pos = (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild").position();
                    var nextLeft = pos.left += deltaX;
                    var nextTop = pos.top += deltaY;
                    // Bewegung nur ausführen, falls sie nicht über die Grenzen
                    // hinausgeht
                    if (nextLeft < bLeft) (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild").css("left", bLeft);
                    else if (nextLeft > bRight) (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild").css("left", bRight);
                    else (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild").css("left", nextLeft);
                    if (nextTop < bTop) (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild").css("top", bTop);
                    else if (nextTop > bBottom) (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild").css("top", bBottom);
                    else (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(".welt_bild").css("top", nextTop);
                    e.preventDefault();
                }
            };
        }
    });
    /* RESIZE-Event (Fenster wird verkleinert / vergrößert) */ (0, $ba66a6f7d5ce89bd$var$_jquery["default"])(window).on("resize", function() {
        viewport();
    /* Ausgabe der Viewport-Dimensionen, testhalber */ //$('#suche_input_suchbegriff').val(vW[vW.length-1] + ' x ' + vH[vH.length-1]);
    /* Anpassungen bzgl Fenstergröße */ /* Funktion nur aufrufen, wenn die in den Mediaqueries verwendeten Grenzwerte überschritten werden */ /*
    - max-width: 1000 px
    - max-width: 920 px
    - max-width: 768 px
    - max-width: 654 px
    - max-width: 480 px
    */ /*let grenzwerte = new Array(1200,1024,768,640,480,360);
    for (let i in grenzwerte) {
    // Differenz von Grenzwert zu letzter und aktueller Viewportbreite ermitteln
    // Wenn eine Differenz positiv und die andere negativ ist, wurde die Grenze überschritten
    // Das ist der Fall, wenn das Produkt der Differenzen negativ oder null ist
    if ( ((grenzwerte[i] - vW[vW.length-2]) * (grenzwerte[i] - vW[vW.length-1])) <= 0 ) {
    //$('#suche_input_suchbegriff').val('Grenze bei ' + grenzwerte[i] + ' passiert');
    viewport();
    break;
    }
    }*/ });
    var _ifComplete = function ifComplete() {
        if (++attempts > 30) return;
        if (document.readyState === "complete") {
            viewport();
            setTimeout(function() {
                return viewport();
            }, 1000);
            setTimeout(function() {
                return viewport();
            }, 3000);
        } else setTimeout(function() {
            return _ifComplete();
        }, 100);
    };
    _ifComplete();
};

});


//# sourceMappingURL=karte.module.1b237c30.js.map
